import { checkNotifications } from '../../redux/slices/notificationsSlice'
import { useSelector, useDispatch } from 'react-redux'
import { DefaultState } from '../../types'
import { useEffect } from 'react'
import './NotificationIcon.css'
import store from '../../redux'
import '../../wdyr'

const NotificationIcon = ({icon, top}: {icon:string, top:string}) => {
  const numOfUnreadNotifications = useSelector(
    (state: DefaultState) => state.notifications.notificationObj.numOfUnreadNotifications
  )
  const error = useSelector(
    (state: DefaultState) => state.notifications.error
  )
  //const [currentTimeout, setCurrentTimeout] = useState<null | NodeJS.Timeout>(0)
  const dispatch = useDispatch()

  useEffect(() => {
    // Dispatch on initial load
    dispatch(checkNotifications())
  }, [])

  useEffect(() => {
    const loadNotifications = setInterval(() => {
        store.dispatch(checkNotifications())
    }, 10000)
    return () => {
      clearInterval(loadNotifications)
    }
  }, [])

  useEffect(() => {
    console.log('Error updating notifications', error)
  }, [error])

  const notificationCount = numOfUnreadNotifications > 0 ? <div className='notification-icon'>{numOfUnreadNotifications}</div> : <></>
  return (
    <span id='notification_icon' className={numOfUnreadNotifications == 0 ? `glyphicons glyphicons-${icon}` : `notification ${top}`} > 
      {notificationCount}
     </span>
  ) 
 
}
NotificationIcon.whyDidYouRender = true
export default NotificationIcon
